export default "__VITE_ASSET__uDg9M1YF__"